@if (display$ | async) {
  <mat-slide-toggle #mode class="mode" [checked]="quickQuoteMode$ | async" (change)="toggled(mode.checked)" i18n>Quick Quote</mat-slide-toggle>
}
